// @ts-nocheck
import { BET_BANNER_ITEM_CHANGED, BET_BANNER_LIST_RECEIVED } from '../../types';

const initialState = {
    list: [],
    current: null,
};

const betBanner = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case BET_BANNER_LIST_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        case BET_BANNER_ITEM_CHANGED: {
            return {
                ...state,
                current: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default betBanner;
